import React from 'react';
import { journeySteps } from '../../data/proposal';
export function ExamplePanel() {
  return <div data-id="element-36" data-mp="2hn1ptxi3e7ml">
      <h2 className="max-w-3xl text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-37" data-mp="2hmi3m4lesx2r">
        One possible way to make a REKOVELLE benefit interactive
      </h2>
      <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-38" data-mp="2rdmjr7mtmnz6">
        For this prototype, we built a 30–45 second teaser around individualized first-cycle dosing. The HCP answers a simple
        clinical question, explores the challenge for a moment — and the REKOVELLE benefit arrives as the answer.
      </p>
      <p className="mt-4 max-w-2xl text-base leading-relaxed text-navy/55" data-id="element-39" data-mp="23n0iq0b8i3yo">
        This prototype is one possible expression of the Snakker model. The final campaign idea, clinical story and execution
        would be developed together with Ferring.
      </p>

      <ol className="mt-8 grid gap-px overflow-hidden rounded-xl border border-navy/10 bg-navy/10 sm:grid-cols-3 lg:grid-cols-6" data-id="element-40" data-mp="3k1ingwat5g5g">
        {journeySteps.map(s => <li key={s.label} className={`flex flex-col p-4 ${s.highlight ? 'bg-[#f2f6fb]' : 'bg-white'}`} data-id="element-41" data-mp="1w23z9xom9m6y">
            <span className={`text-sm font-medium leading-snug ${s.highlight ? 'text-ferring' : 'text-navy'}`} data-id="element-42" data-mp="1n3ryx3xy7a1b">{s.label}</span>
            <span className="mt-1 text-xs leading-snug text-navy/55" data-id="element-43" data-mp="1i570na29b0fi">{s.detail}</span>
          </li>)}
      </ol>

      <p className="mt-8 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-44" data-mp="1d6duy3t7odpw">
        It starts with the clinical idea, not the product claim — <span className="text-navy" data-id="element-45" data-mp="18crh48bba3si">what are we trying to achieve with
        ovarian stimulation?</span> REKOVELLE then enters naturally as one way of approaching that challenge. The same principle
        could be applied to whichever REKOVELLE benefit Ferring believes is most strategically important.
      </p>

      <p className="mt-10 max-w-3xl border-l-2 border-ferring pl-6 text-[26px] font-medium leading-[1.15] tracking-[-0.025em] text-navy md:text-[32px]" data-id="element-46" data-mp="pg0065j8s0rm">
        The specific creative execution can change. The principle does not: make the benefit interactive.
      </p>
    </div>;
}